export const foundationStates = ['formed', 'pre-formation'];
